<template>
  <footer class="footer-wrapper clearfix">
    <div class="footer ws-footer">
      <div class="container ws-footer__inner">
        <!-- 19443 - Only hide this for Luxair mobile -->
        <p v-if="!isLG" class="ws-footer__text">powered by Stranded Flight Solutions</p>
        <p v-else class="ws-footer__text"></p>
        <p class="ws-footer__text">V8.40</p>
      </div>
    </div>
  </footer>
</template>
<script>
import '@/assets/scss/modules/Footer.scss'

export default {
  name: 'Footer',
  computed: {
    isLG() {
      return this.airline?.code?.toLowerCase() == 'lg' || window.location.hostname.toLowerCase().includes('lg')
    }
  }
}
</script>
